import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { RBACService } from '../../shared/rbac.service';

@Component({
  selector: 'app-employees-importer',
  templateUrl: './employees-importer.component.html',
  styleUrls: ['./employees-importer.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EmployeesImporterComponent implements OnInit {
  constructor(public rbac: RBACService, private router: Router) {}

  ngOnInit() {
    // RBAC: Check employees:create permission for importer access.
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_EMPLOYEES,
            RBACService.RBAC_A.A_CREATE
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to access the employee importer.'
      );
      this.router.navigate(['/employees']);
      return;
    }
  }
}
